import axios from 'axios';
import CONSTS from '../../config/constants';
import Env from '../../config/environment';
import FileSaver from 'file-saver';

const { API_APP } = CONSTS.SERVICES;
const env = Env();
const version = env.app.version;

export const getAssets = (id) => axios.get(`/b/docs/${version}/documents/${id}/assets`, {
  headers: {
    service: API_APP,
  },
});

export const juridicCertificate = (id) => axios.get(`/b/docs/${version}/juridicCertificate/${id}/download`, {
  headers: {
    service: API_APP,
  },
}).then(response => {
  const pdfData = response.data.payload.replace('data:application/pdf;base64,', '');
  var arrayBuffer = Buffer.from(pdfData, 'base64');
  const blob = new Blob([arrayBuffer], { type: 'application/pdf;charset=utf-8' });
  FileSaver.saveAs(blob, `cert_${id}.pdf`);
});